import { CreateRouterOptions } from '@/typings/common'

import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { createRoutes, registerMenu } from './routes'


type Options = Required<CreateRouterOptions>

Vue.use(VueRouter)

export const createRouter = (options: CreateRouterOptions) => {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    scrollBehavior(to: Route, from: Route, savedPosition: unknown): any {
      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      if (to.params.savePosition) return {}
      if (to.path === from.path) return false
      if (savedPosition) return savedPosition
      return { y: 0 }
    },
    routes: [],
  })

  const opt: Options = { ...options, router }
  void registerMenu(opt)

  const routes = createRoutes(opt)
  // @ts-ignore TODO
  router.routes = routes
  routes.forEach((route) => {
    router.addRoute(route)
  })

  return router
}
